import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

const ADMIN_CREDENTIALS = {
  email: 'admin',
  password: '123zerofold',
};

const STORAGE_KEY = 'invoice-app-user';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem(STORAGE_KEY);
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error('Error reading auth from storage:', error);
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    try {
      if (user) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      console.error('Error writing auth to storage:', error);
    }
  }, [user]);

  const login = (email, password) => {
    if (email === ADMIN_CREDENTIALS.email && password === ADMIN_CREDENTIALS.password) {
      const loggedUser = { uid: 'admin-local', email: 'admin' };
      setUser(loggedUser);
      return Promise.resolve(loggedUser);
    }

    return Promise.reject(new Error('Invalid credentials.'));
  };

  const signup = () => {
    return Promise.reject(new Error('Signup is disabled. Use default credentials.'));
  };

  const logout = () => {
    setUser(null);
    return Promise.resolve();
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
